"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.747 2c-.748 0-1.466.298-1.995.826L2.825 6.754A2.82 2.82 0 0 0 2 8.747v6.505c0 .749.297 1.467.826 1.995l3.928 3.928A2.82 2.82 0 0 0 8.747 22h6.505c.749 0 1.467-.297 1.996-.826l3.927-3.93A2.822 2.822 0 0 0 22 15.253V8.75c0-.749-.297-1.468-.827-1.998l-3.926-3.926A2.822 2.822 0 0 0 15.25 2H8.747ZM12.7 7.5a.7.7 0 1 0-1.4 0v6a.7.7 0 1 0 1.4 0v-6Zm-.584 8.507L11.999 16l-.11.006A.999.999 0 1 0 13 17a1 1 0 0 0-.883-.993Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AlertErrorFilledIcon24.js.map